import * as Sentry from '@sentry/vue';
import Vue from 'vue';

const options = {
  enabled          : process.env.SENTRY_DISABLED === 'false',
  dsn              : process.env.SENTRY_DSN,
  environment      : process.env.SENTRY_ENVIRONMENT,
  tracesSampleRate : 0.01,
  trackComponents  : true,
  hooks            : ['mount', 'update'],
  timeout          : 2000,
  release          : process.env.SENTRY_RELEASE
};

export default ({ app }, inject) => {
  Sentry.init({
    Vue,
    ...options
  });

  inject('sentry', Sentry);
};

export {
  options
};
